exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".status-bg-color[data-v-38762604]{display:flex;justify-content:flex-start;border-radius:10px;color:#fff;gap:4px;font-size:10px;align-items:center;flex-wrap:wrap;padding-left:5px;height:14px;width:90px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-38762604","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/views/components/status.vue
// module id = 878
// module chunks = 0